<template>
  <Layout @locale-search="allReqs">
    <div class="charts" v-if="!loading && fleetCount > 0">
      <div class="banner-of-row">
        <transition appear enter-active-class="animated fadeIn">
          <q-banner id="hide-on-mobile" dense :class="fleetCount !== 0 ? 'bg-info' : 'bg-negative'"
            class="text-white first">{{ filterData }}
          </q-banner>
        </transition>
        <transition appear enter-active-class="animated fadeIn">
          <q-banner dense :class="fleetCount !== 0 ? 'bg-primary' : 'bg-negative'" class="text-white end">Fleet Count : {{
            fleetCount }}
          </q-banner>
        </transition>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4" style="padding: 5px;">
          <q-card class="chart-card">
            <div class="size-change-wrapper" v-if="fleetSizeChange !== null && fleetSizeChange.today_size !== null">
              <div class="section">
                <div class="title">Today Size</div>
                <p class="result">{{ fleetSizeChange.today_size }}</p>
              </div>
              <div class="section">
                <div class="title">Last Week Average</div>
                <p class="result">{{ fleetSizeChange.last_week_avg }}</p>
              </div>
              <div class="section">
                <div class="title">Difference</div>
                <p :class="fleetSizeDiff > 0 ? 'green result' : fleetSizeDiff === 0 ? 'result' : 'red result'">{{ fleetSizeDiff }}</p>
              </div>
            </div>
            <div class="size-change-wrapper" v-else>No data available.</div>
          </q-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4" style="padding: 5px;">
          <q-card class="chart-card">
            <div class="table" v-if="topBrandsData.length > 0">
              <h2>Top Brands</h2>
              <table>
                <thead>
                  <tr>
                    <th>Brand</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in topBrandsData" :key="index">
                    <td>{{ data.brand }}</td>
                    <td>{{ data.count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="size-change-wrapper" v-else>No data available.</div>
          </q-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4" style="padding: 5px;">
          <q-card class="chart-card">
            <div class="table" v-if="topFinanceData.length > 0">
              <h2>Top Finance Source</h2>
              <table>
                <thead>
                  <tr>
                    <th>Brand</th>
                    <th>Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in topFinanceData" :key="index">
                    <td>{{ data.brand }}</td>
                    <td>{{ data.count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="size-change-wrapper" v-else>No data available.</div>
          </q-card>
        </div>
      </div>
      <div class="chart-item">
        <div class="chart-item-half" v-if="three3Dchart.series[0].data.length > 0">
          <q-card class="chart-card">
            <vue-highcharts :options="three3Dchart"></vue-highcharts>
          </q-card>
        </div>
        <div class="chart-item-half" v-if="highchartOption.series.length > 0">
          <q-card class="chart-card">
            <vue-highcharts :options="highchartOption" ref="barChart"></vue-highcharts>
          </q-card>
        </div>
        <q-dialog v-model="isGroupClassesModalOpen">
          <q-card class="modal-chart" @keydown.esc="isGroupClassesModalOpen = false">
            <vue-highcharts v-if="three3DchartForComposition.series.length > 0"
              :options="three3DchartForComposition"></vue-highcharts>
          </q-card>
        </q-dialog>
        <div class="chart-item-half" v-if="ownershipOptions.series[0].data.length > 0">
          <q-card class="chart-card">
            <vue-highcharts :options="ownershipOptions" ref="ownerChart"></vue-highcharts>
          </q-card>
        </div>
        <div class="chart-item-half" v-if="paymentMonthlyByClass.xAxis.categories.length > 0">
          <q-card class="chart-card">
            <vue-highcharts :options="paymentMonthlyByClass"></vue-highcharts>
          </q-card>
        </div>
        <div class="chart-item-half" v-if="paymentTotalByClass.xAxis.categories.length > 0">
          <q-card class="chart-card">
            <vue-highcharts :options="paymentTotalByClass"></vue-highcharts>
          </q-card>
        </div>
        <div class="chart-item-half" v-if="positiveEquity.xAxis.categories.length > 0">
          <q-card class="chart-card">
            <vue-highcharts :options="positiveEquity"></vue-highcharts>
          </q-card>
        </div>
      </div>
    </div>
    <div v-else-if="!loading && fleetCount === 0" class="charts">
      <q-card style="padding: 15px">
        <empty-value name="data to show charts"></empty-value>
      </q-card>
    </div>
    <div v-else style="width: 100%; margin-top: 57px">
      <q-card v-if="loading" style="width: 100%">
        <Loading />
      </q-card>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/Layout";
import EmptyValue from "../components/EmptyValue";
import Loading from "../components/Loading";
import axios from "../axios/index";
import { Chart } from "highcharts-vue";
export default {
  components: {
    EmptyValue,
    VueHighcharts: Chart,
    Loading,
    Layout,
  },
  metaInfo() {
    return {
      title: "Dashboard Report for overview of Current Fleet | FMS",
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: "",
        },
        {
          property: "og:title",
          content: "FMS - Dashboard Report for overview of Current Fleet",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      topBrandsData: null,
      topFinanceData: null,
      fleetSizeChange: null,
      fleetSizeDiff: null,
      colors: [
        "#003f5c",
        "#58508d",
        "#bc5090",
        "#ff6361",
        "#ffa600",
        "#01befe",
        "#ffdd00",
        "#ff7d00",
        "#ff006d",
        "#adff02",
        "#8f00ff",
      ],
      highchartOption: {
        chart: {
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: "Fleet Composition by Location",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
          title: {
            text: "Count Of Vehicles %",
            style: {
              fontSize: "20px",
              fontWeight: "700",
              color: "#ccc",
            },
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        },
        plotOptions: {
          column: {
            stacking: "percent",
            allowPointSelect: false,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              formatter: function () {
                const percentageOfData =
                  Math.round(this.percentage * 100) / 100;
                if (percentageOfData > 0) {
                  return this.series.name;
                }
              },
              distance: 0,
              color: "white",
            },
            showInLegend: true,
          },
        },
        credits: {
          enabled: false,
        },
        series: [],
      },
      three3Dchart: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          style: {
            fontFamily: "Roboto",
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        title: {
          text: "Fleet Composition",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              distance: 15,
              //color: "white",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: "pie",
            name: "Vehicle Count",
            data: [],
          },
        ],
      },
      three3DchartForComposition: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          style: {
            fontFamily: "Roboto",
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        title: {
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "16px",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              distance: 15,
              //color: "white",
            },
            showInLegend: true,
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        },
        series: [
          {
            type: "pie",
            name: "Vehicle Count",
            data: [],
          },
        ],
      },
      ownershipOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          style: {
            fontFamily: "Roboto",
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        title: {
          text: "Ownership Type Percentage",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              distance: 15,
              //color: "white",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: "pie",
            name: "Vehicle Count",
            data: [],
          },
        ],
      },
      topBrands3Dchart: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          style: {
            fontFamily: "Roboto",
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        title: {
          text: "Top Brands",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              distance: 15,
              //color: "white",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: "pie",
            name: "Vehicle Count",
            data: [],
          },
        ],
      },
      topFinance3Dchart: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "pie",
          style: {
            fontFamily: "Roboto",
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
        },
        title: {
          text: "Top Finance Source",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
              distance: 15,
              //color: "white",
            },
            showInLegend: true,
          },
        },
        series: [
          {
            type: "pie",
            name: "Vehicle Count",
            data: [],
          },
        ],
      },
      paymentMonthlyByClass: {
        chart: {
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: "Avg of Monthly Payment by Vehicle Class",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
          title: {
            text: "Avg of Monthly Payment",
            style: {
              fontSize: "20px",
              fontWeight: "700",
              color: "#ccc",
            },
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>${point.y}</b><br/> <span>Count: {point.count} </span>',
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Payment",
            data: [],
          },
        ],
      },
      paymentTotalByClass: {
        chart: {
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: "Total of Monthly Payment by Vehicle Class",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total of Monthly Payment",
            style: {
              fontSize: "20px",
              fontWeight: "700",
              color: "#ccc",
            },
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>${point.y:,.2f}</b><br/> <span>Count: {point.count} </span>',
        },

        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Payment",
            data: [],
          },
        ],
      },
      positiveEquity: {
        chart: {
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: "Classes Have Positive Equity",
          style: {
            color: "#ccc",
            fontWeight: "bold",
            fontSize: "24px",
          },
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          min: 0,
          title: {
            text: "Profit",
            style: {
              fontSize: "20px",
              fontWeight: "700",
              color: "#ccc",
            },
          },
          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: "",
          pointFormat:
            '<span style="color:#00E676">{series.name}</span>: <b>${point.y:,.0f}</b><br/> <span>Count: {point.count} </span>',
        },

        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Profit",
            data: [],
          },
        ],
      },
      isGroupClassesModalOpen: false,
      groupClassesModalData: null,
      filterData: "",
      firstRequest: true,
    };
  },
  mounted() {
    this.allReqs();
  },
  methods: {
    async allReqs() {
      this.resetter();
      this.loading = true;
      this.filterShower();
      try {
        await Promise.all([
          this.getFleetCount(),
          this.getFleetComposition(),
          this.getFleetCompositionViaLocs(),
          this.getFleetCountByOwner(),
          this.getPaymentForClass(),
          this.getPositiveEquity(),
          this.getFleetTopBrands(),
          this.getFleetSizeChange(),
          this.getFleetTopFinance(),
        ]);
      } catch (error) {
      } finally {
        this.loading = false;
        this.query = false;
      }
    },
    async getPaymentForClass() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        statuses: params.statuses
      };
      const { data } = await axios.post(
        "vehicle-analysis/monthly-payment-by-class",
        {},
        {
          params: withoutQ,
        }
      );
      data.data.map((item) => {
        this.paymentMonthlyByClass.xAxis.categories.push(item.class_name);
        this.paymentTotalByClass.xAxis.categories.push(item.class_name);
        this.paymentMonthlyByClass.series[0].data.push({
          y: item.values.average,
          total: item.values.total,
          count: item.values.count,
          color: "#00466f",
        });
        this.paymentTotalByClass.series[0].data.push({
          y: item.values.total,
          color: "#00466f",
          count: item.values.count,
        });
      });
    },
    async getPositiveEquity() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        provider: params.provider,
        statuses: params.statuses
      };
      const { data } = await axios.post(
        "vehicle-analysis/positive-equity-by-class",
        {},
        {
          params: withoutQ,
        }
      );
      data.data.map((item) => {
        this.positiveEquity.xAxis.categories.push(item.class_name);
        this.positiveEquity.series[0].data.push({
          y: item.values.total,
          color: "#00E676",
          count: item.values.count,
        });
      });
    },
    async getFleetCountByOwner() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        statuses: params.statuses
      };
      const { data } = await axios.post(
        "vehicle-analysis/count-by-ownership",
        {},
        { params: withoutQ }
      );
      let index = 0;
      for (const key in data.data) {
        index = Object.keys(data.data).indexOf(key);
        if (data.data.hasOwnProperty(key)) {
          if (key !== "total" && data.data[key] !== 0) {
            var name;
            if (key === "lease") name = "Closed-End Lease";
            else if (key === "loan") name = "Finance";
            else if (key === "other") name = "Not Identified";
            this.ownershipOptions.series[0].data.push({
              name,
              y: data.data[key],
              color: this.colors[index],
            });
          }
        }
      }
    },
    queryHandler() {
      const params = {};
      if (this.companyFilter.id) params.company_id = this.companyFilter.id;
      if (this.search) params.q = this.search;
      if (this.provider) params.provider = this.provider.key;
      if (this.multiFilter.length > 0) params.locationId = this.multiFilter.map(item => item.id);
      if (this.statusFilter.length > 0) params.statuses = this.statusFilter.map(item => item.value);
      return { params };
    },
    async getFleetCompositionViaLocs() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        statuses: params.statuses
      };
      const {
        data,
      } = await axios.post(
        "vehicle-analysis/fleet-composition-by-location",
        {},
        { params: withoutQ }
      );
      this.fleetCompositionViaLocations = data.data;
      var obj = {};

      for (let i = 0; i < data.data.length; i++) {
        this.highchartOption.xAxis.categories.push(data.data[i].location);
        for (let index = 0; index < data.data[i].values.length; index++) {
          const element = data.data[i].values[index];
          if (typeof obj[element.group_name] === "undefined") {
            obj[element.group_name] = [];
          }
        }
      }
      const showClassesModal = (index, group) => {
        try {
          const locationData = this.fleetCompositionViaLocations[index]
          const classesData = locationData.values.find(v => v.group_name === group)
          this.three3DchartForComposition.title.text = `${locationData.location} - ${classesData.group_name}`
          this.three3DchartForComposition.series[0].data = classesData.classes.map(c => {
            return {
              name: c.class_name,
              y: c.count,
              color: this.colors[classesData.classes.indexOf(c)]
            }
          })
          this.isGroupClassesModalOpen = true
        } catch (error) {
          console.log(error)
        }
      }
      Object.keys(obj).forEach((key, index) => {
        for (let index = 0; index < data.data.length; index++) {
          const element = data.data[index];
          const value = element.values.find(v => v.group_name === key);
          if (value) {
            obj[key].push(value.count);
          } else {
            obj[key].push(0);
          }
        }
        this.highchartOption.series.push({
          name: key,
          data: obj[key],
          color: this.colors[index],
          point: {
            events: {
              click: function (event) {
                showClassesModal(event.point.x, key);
              }.bind(this),
            }
          }
        });
      });
    },
    async getFleetComposition() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        statuses: params.statuses
      };
      const { data } = await axios.post(
        "vehicle-analysis/fleet-composition",
        {},
        { params: withoutQ }
      );
      this.fleetComposition = data.data;
      this.fleetComposition.map((item, index) => {
        if (item.count > 0) {
          this.three3Dchart.series[0].data.push({
            name: item.class_name,
            y: item.count,
            sliced: true,
            color: this.colors[index],
          });
        }
      });
    },
    async getFleetCount() {
      let { params } = this.queryHandler();
      let p = {
        q: params.q,
        location_id: params.locationId,
        company_id: params.company_id,
        statuses: params.statuses
      };
      const { data } = await axios.post("vehicle-analysis/count", {}, {
        params: p,
      });
      this.fleetCount = data.data.count;
    },
    async getFleetTopBrands() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        statuses: params.statuses,
        limit: 3
      };
      let url = '?limit=' + withoutQ.limit

      if (withoutQ.company_id?.length) {
        url += '&company_id=' + withoutQ.company_id
      } if (withoutQ.location_id?.length) {
        url += '&location_id=' + withoutQ.location_id
      } if (withoutQ.statuses?.length) {
        withoutQ.statuses.map((item, index) => {
          url += '&statuses[]=' + item
        })
      }

      const { data } = await axios.get(
        "vehicle-analysis/top-brands" + url
      );
      this.topBrands = await data.data;
      this.topBrandsData = this.topBrands;
      this.topBrands.map((item, index) => {
        if (item.count > 0) {
          this.topBrands3Dchart.series[0].data.push({
            name: item.brand,
            y: item.count,
            sliced: true,
            color: this.colors[index],
          });
        }
      });
    },
    async getFleetTopFinance() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
        location_id: params.locationId,
        statuses: params.statuses,
        limit: 3
      };
      let url = '?limit=' + withoutQ.limit
      if (withoutQ.company_id?.length) {
        url += '&company_id=' + withoutQ.company_id
      } if (withoutQ.location_id?.length) {
        url += '&location_id=' + withoutQ.location_id
      } if (withoutQ.statuses?.length) {
        withoutQ.statuses.map((item, index) => {
          url += '&statuses[]=' + item
        })
      }
      const { data } = await axios.get(
        "vehicle-analysis/top-finance-source" + url
      );
      this.topFinanceSource = await data.data;
      this.topFinanceData = this.topFinanceSource;
      this.topFinanceSource.map((item, index) => {
        if (item.count > 0) {
          this.topFinance3Dchart.series[0].data.push({
            name: item.brand,
            y: item.count,
            sliced: true,
            color: this.colors[index],
          });
        }
      });
    },
    async getFleetSizeChange() {
      const { params } = this.queryHandler();
      const withoutQ = {
        company_id: params.company_id,
      };
      let url = ''
      if (withoutQ.company_id?.length) {
        url += '&company_id=' + withoutQ.company_id
      }
      if (withoutQ.statuses?.length) {
        withoutQ.statuses.map((item, index) => {
          url += '&statuses[]=' + item
        })
      }
      const { data } = await axios.get(
        "vehicle-analysis/fleet-size-change" + url,
      );
      this.fleetSizeChange = await data.data;
      this.fleetSizeDiff = Number(this.fleetSizeChange.today_size) - Number(this.fleetSizeChange.last_week_avg)
    },
    resetter() {
      this.topFinance3Dchart.series[0].data = [];
      this.topBrands3Dchart.series[0].data = [];
      this.three3Dchart.series[0].data = [];
      this.three3DchartForComposition.series[0].data = [];
      this.highchartOption.series = [];
      this.highchartOption.xAxis.categories = [];
      this.ownershipOptions.series[0].data = [];
      this.paymentMonthlyByClass.xAxis.categories = [];
      this.paymentMonthlyByClass.series[0].data = [];
      this.paymentTotalByClass.xAxis.categories = [];
      this.paymentTotalByClass.series[0].data = [];
      this.positiveEquity.xAxis.categories = [];
      this.positiveEquity.series[0].data = [];
    },
    async getLocations(companyId) {
      if (companyId) {
        try {
          const params = { company_id: companyId };
          const { data } = await axios.get(`locations`, { params });
          this.locations = data.data;
        } catch (error) {
        } finally {
        }
      }
    },
    filterShower() {
      const { companyId, ids, search } = this.paramsWatcher;
      if (!companyId && ids.length === 0 && !search)
        this.filterData = "All Locations";
      else
        this.filterData = `${this.companyFilter && this.companyFilter.name
          ? this.multiFilter.length > 0
            ? `${this.companyFilter.name},`
            : this.companyFilter.name
          : ""
          } ${this.multiFilter.map((item) =>
            this.multiFilter.length > 1 ? `${item.code}-` : item.code
          )}`;
    },
  },
  computed: {
    loading: {
      get() {
        return this.$store.state.analysis.loading;
      },
      set(val) {
        this.$store.commit("analysis/SET_LOADING", val);
      },
    },
    drawer() {
      return this.$store.state.layout.drawer;
    },
    query: {
      get() {
        return this.$store.state.analysis.query;
      },
      set(val) {
        this.$store.commit("analysis/SET_QUERY", val);
      },
    },
    multiFilter: {
      get() {
        return this.$store.state.analysis.multiFilter;
      },
      set(val) {
        this.$store.commit("analysis/SET_MULTI_FILTER", val);
      },
    },
    statusFilter: {
      get() {
        return this.$store.state.analysis.statusFilter;
      },
      set(val) {
        this.$store.commit("analysis/SET_STATUS_FILTER", val);
      },
    },
    companyFilter() {
      return this.$store.state.analysis.companyFilter;
    },
    fleetCompositionViaLocations: {
      get() {
        return this.$store.state.analysis.fleetCompositionViaLocations;
      },
      set(val) {
        this.$store.commit("analysis/SET_FLEET_COMPOSITION_VIA_LOCS", val);
      },
    },
    fleetComposition: {
      get() {
        return this.$store.state.analysis.fleetComposition;
      },
      set(val) {
        this.$store.commit("analysis/SET_FLEET_COMPOSITION", val);
      },
    },
    fleetCount: {
      get() {
        return this.$store.state.analysis.fleetCount;
      },
      set(val) {
        this.$store.commit("analysis/SET_FLEET_COUNT", val);
      },
    },
    search() {
      return this.$store.state.analysis.search;
    },
    locations: {
      get() {
        return this.$store.state.vehicle.locations;
      },
      set(val) {
        this.$store.commit("vehicle/SET_LOCATIONS", val);
      },
    },
    provider: {
      get() {
        return this.$store.state.analysis.provider;
      },
      set(val) {
        this.$store.commit("analysis/SET_PROVIDER", val);
      },
    },
    paramsWatcher() {
      const watcher = {
        ids: this.multiFilter.map((item) => item.id),
        companyId: this.companyFilter.id,
        search: this.search,
        provider: this.provider,
      };
      return watcher;
    },
  },
  watch: {
    drawer() {
      if (this.$q.screen.gt.sm) {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    companyFilter(n, o) {
      this.multiFilter = [];
      n && n.id ? this.getLocations(n.id) : "";
    },
    // paramsWatcher: {
    //   handler(n, o) {
    //     this.resetter();
    //     this.allReqs();
    //   },
    // },
  },
};
</script>

<style lang="scss">
.size-change-wrapper {
  display: flex;
  padding: 21px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 320px;

  .title {
    margin-top: 1px;
    font-size: 20px;
    font-weight: 700;
  }
  .result { 
    font-size: 20px;
    margin-top: 3px;
    font-weight: 500;
  }

  .section {
    text-align: center;
  }

  p {
    font-size: 18px;
  }

  .red {
    color: rgb(230, 89, 89)
  }

  .green {
    color: rgb(0, 230, 118)
  }
}

.charts {
  margin-top: 57px;
  display: flex;
  flex-flow: column nowrap;
  width: 100%;

  .banner-of-row {
    padding: 0 5px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .chart-item {
    display: block;

    .chart-item-half {
      margin: 5px 5px 10px;
      float: left;
      width: calc(50% - 10px);
    }

    .chart-item-quarter {
      margin: 5px 5px 10px;
      float: left;
      width: calc(33% - 10px);
    }
  }
}

.table {
  width: 100%;
  height: 320px;
  overflow-y: auto;

  h2 {
    text-align: center;
    font-size: 24px;
    margin: 0;
    color: #ccc;
    font-weight: bold;
  }

  table {
    width: 100%;

    th {
      padding: 5px 10px;
      font-size: 18px;
      font-weight: 700;
      color: #afafaf;

      &:first-child {
        width: 50%;
        text-align: left !important;
      }
    }

    tbody {
      tr {
        border-right: 1px solid #747474;

        &:last-child {
          border-bottom: none;
        }



        &:nth-child(odd) {
          background-color: #ebebeb;
        }

        &:nth-child(even) {
          background-color: #fff;
        }

        td {
          padding: 5px 10px;
          font-size: 16px;
          font-weight: 700;
          color: #444;

          &:first-child {
            width: 50%;
            text-align: left !important;
          }
        }
      }
    }

  }
}

.modal-chart {
  padding: 10px;
  width: 360px;

  .highcharts-title {
    > tspan {
      font-size: 16px !important;
    }
  }

  .highcharts-legend-item {
    tspan {
      font-size: 14px !important;
    }
  }
}

@media screen and (max-width: 1440px) {
  .charts {
    .chart-item {
      .chart-item-half {
        margin-top: 5px;
        width: calc(100% - 10px) !important;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .charts {
    .banner-of-row {
      div {
        display: flex;
        flex-flow: column nowrap;
        align-self: flex-start;
        flex: 1;
      }
    }

    #hide-on-mobile {
      display: none !important;
    }
  }
}
</style>
